import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { dedupeByPath, normalizePath } from "./_helpers/path";

export type RecentVisit = {
  path: string;
  title: string;
  visitedAt: number;
};

type RecentVisitsState = {
  recentVisits: RecentVisit[];
  addVisit: (visit: Pick<RecentVisit, "path" | "title">) => void;
};

export const MAX_RECENT_VISITS = 5;

export const recentVisitsStore = create<RecentVisitsState>()(
  devtools(
    persist(
      (set) => ({
        recentVisits: [],
        addVisit: ({ path, title }) => {
          const normalizedPath = normalizePath(path);

          set((state) => ({
            recentVisits: [
              { path: normalizedPath, title, visitedAt: Date.now() },
              ...state.recentVisits.filter((visit) => visit.path !== normalizedPath),
            ].slice(0, MAX_RECENT_VISITS),
          }));
        },
      }),
      {
        name: "recent-visits-store",
        version: 1,
        migrate: (persistedState: unknown) => {
          const state = persistedState as RecentVisitsState;
          const normalizedVisits = (state.recentVisits ?? []).map((visit) => ({
            ...visit,
            path: normalizePath(visit.path),
          }));

          return { ...state, recentVisits: dedupeByPath(normalizedVisits).slice(0, MAX_RECENT_VISITS) };
        },
      },
    ),
    { name: "recent-visits-store" },
  ),
);
